import { Mail, MapPin, Linkedin, Instagram } from "lucide-react";
import { CONTACT } from "../lib/site";
import AnimatedLogo from "./AnimatedLogo";
import { scrollToId } from "../lib/scroll";

const FOOTER_LINKS = [
  { id: "services", label: "Services" },
  { id: "manifesto", label: "Why Us" },
  { id: "clients", label: "Clients" },
  { id: "pricing", label: "Pricing" },
  { id: "news", label: "Industry News" },
  { id: "contact", label: "Contact" },
];

const Footer = () => (
  <footer
    data-testid="footer-section-container"
    className="relative overflow-hidden border-t border-slate-200 bg-white"
  >
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 sm:px-8">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <span className="flex items-center gap-4">
            <AnimatedLogo className="h-12 w-12" onView testId="footer-brand-logo" />
            <img
              src="/logo-wide.png"
              alt="Artwork360 — 360° Solutions For Promotional Excellence"
              className="h-14 w-auto object-contain"
            />
          </span>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-slate-500">
            Live order management and graphic design services for promotional
            products distributors across the US, Canada, UK, and Australia.
          </p>
          <p data-testid="footer-business-hours-text" className="mt-4 font-mono2 text-[10px] uppercase tracking-[0.22em] text-[#2E3192]">
            {CONTACT.hoursLine}
          </p>
          <div className="mt-6 flex gap-3">
            <a
              href="https://www.linkedin.com/company/artwork-360"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Artwork360 on LinkedIn"
              data-testid="footer-social-linkedin"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-300 text-slate-500 transition-colors hover:border-[#6DC8F0]/60 hover:text-[#2E3192]"
            >
              <Linkedin className="h-4 w-4" />
            </a>
            <a
              href="https://www.instagram.com/artwork.360"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Artwork360 on Instagram"
              data-testid="footer-social-instagram"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-300 text-slate-500 transition-colors hover:border-[#6DC8F0]/60 hover:text-[#2E3192]"
            >
              <Instagram className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div className="lg:col-span-3">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-slate-500">
            Quick Links
          </p>
          <ul className="mt-5 space-y-3">
            {FOOTER_LINKS.map((l) => (
              <li key={l.id}>
                <button
                  onClick={() => scrollToId(l.id)}
                  className="text-sm text-slate-500 transition-colors hover:text-[#2E3192]"
                >
                  {l.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.28em] text-slate-500">
            Get in Touch
          </p>
          <a
            href={`mailto:${CONTACT.email}`}
            className="mt-5 flex items-center gap-2.5 text-sm text-slate-600 transition-colors hover:text-[#2E3192]"
          >
            <Mail className="h-4 w-4 text-[#2E3192]" />
            {CONTACT.email}
          </a>
          <p className="mt-4 flex items-start gap-2.5 text-sm leading-relaxed text-slate-500">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#2E3192]" />
            <span>
              {CONTACT.company}
              <br />
              {CONTACT.address}
            </span>
          </p>
        </div>
      </div>

      <div className="pointer-events-none mt-16 select-none overflow-hidden">
        <p className="whitespace-nowrap text-center font-display text-[13vw] font-extrabold leading-none tracking-tight text-slate-900/[0.06] lg:text-[10rem]">
          ARTWORK360
        </p>
      </div>

      <div className="mt-4 flex justify-center border-t border-slate-200 pt-6">
        <p className="text-xs text-slate-500">
          © 2026 Artwork360 · A venture of {CONTACT.company}. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
